export default __webpack_public_path__ + "static/media/yeoman.f21799d3.svg";